import { cn } from "@/libs/cn";

const gridCols = "md:grid-cols-[7.5fr_6fr_4fr_4.5fr_5fr_7fr_4.5fr_4.5fr_4fr_3.5fr_4.5fr_4.5fr]";
const gridGap = "md:gap-4";
export const gridLayout = cn("flex flex-col gap-2 md:grid md:items-center", gridCols, gridGap, "px-4 md:px-6 py-3 md:py-2");

export const SKELETON_COLUMNS = 12;

const TariffsListHeader = () => {
  const headerStyle = "text-sm text-ui-navy-dark font-semibold text-gray-500 truncate";

  return (
    <div className={cn("hidden md:grid md:items-center", gridCols, gridGap, "bg-white border-b border-gray-100 px-6 py-4")}>
      <span className={headerStyle}>Nome</span>
      <span className={headerStyle}>Distribuidora</span>
      <span className={headerStyle}>Modalidade</span>
      <span className={headerStyle}>Subgrupo</span>
      <span className={headerStyle}>Classe/Categoria</span>
      <span className={headerStyle}>Subclasse</span>
      <span className={headerStyle}>Valor TE</span>
      <span className={headerStyle}>Valor TUSD</span>
      <span className={headerStyle}>Período</span>
      <span className={headerStyle}>Tipo</span>
      <span className={headerStyle}>Início da vigência</span>
      <span className={headerStyle}>Fim da vigência</span>
    </div>
  );
};

export default TariffsListHeader;
